module.exports = __webpack_public_path__ + "images/category_lp/trading_card/assessment_achievements/6_688790af8a7ec75c4d0c8f3c0a283899.png";